import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import qs from 'qs';
import cn from 'classnames';
import DateTimeIntervalDisplay from './DateTimeIntervalDisplay';
import axios from '../lib/axios';
import ModalTrigger from './ModalTrigger';
import AvailabilityPill from './AvailabilityPill';
import DateTimeInput from './DateTimeInput';
import PopoverTrigger from './PopoverTrigger';
import Avatar from './Avatar';
import CardTagLine from './CardTagLine';

const StringUtil = {};
StringUtil.camelize = function (string) {
  return string.replace(/(?:^|[-_])(\w)/g, (_, c) => (c ? c.toUpperCase() : ''));
};

class AgendaEvent extends Component {
  static propTypes = {
    isVirtualFriendly: PropTypes.bool.isRequired,
    isVirtualOnly: PropTypes.bool,
    isPopover: PropTypes.bool,
    className: PropTypes.string,
    isPastSignup: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    onSelectEvent: PropTypes.func,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    communityLogoPath: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isVirtualOnly: undefined,
    className: undefined,
    isPopover: false,
    onSelectEvent: () => {},
  };

  render() {
    let eventClasses = ['u-flex', 'u-items-start', 'AgendaEvent'];
    if (this.props.isAttending || this.props.isHosting || this.props.isPending) {
      eventClasses = eventClasses.concat(['is-attending']);
    }

    if (
      (this.props.isPastSignup || this.props.isBooked) &&
      !this.props.isPast &&
      !this.props.isHosting
    ) {
      eventClasses = eventClasses.concat(['is-unavailable']);
    }

    if (this.props.isPast) {
      eventClasses = eventClasses.concat(['is-past']);
    }

    if (this.props.className) {
      eventClasses = eventClasses.concat(this.props.className);
    }

    return (
      <li className={eventClasses.join(' ')} onClick={() => this.props.onSelectEvent(this.props)}>
        <div className="u-flex-none u-mr-3">
          <div className="AgendaEventDate u-flex u-flex-col">
            <span className="u-text-xl u-leading-none u-align-bottom">
              {moment.tz(this.props.start_date, this.props.useTimezone).format('DD')}
            </span>
            <span className="u-uppercase u-text-xs u-align-top">
              {moment.tz(this.props.start_date, this.props.useTimezone).format('MMM')}
            </span>
          </div>
        </div>
        <div className="u-leading-none u-flex u-flex-col u-truncate u-pb-1">
          <a
            target="_blank"
            href={this.props.url}
            className="u-font-bold u-whitespace-normal u-truncate">
            {this.props.title}
          </a>

          <div className="u-flex u-mt-1 u-mb-2">
            <div className={`u-text-xs u-font-semibold u-text-color-${this.props.cssSufix}`}>
              {this.props.label}
            </div>
            <div className="u-text-xs u-text-grey u-ml-2">
              <DateTimeIntervalDisplay
                show_date={false}
                show_timezone={true}
                useTimezone={this.props.useTimezone}
                start_date={this.props.start_date}
                end_date={this.props.end_date}
              />
            </div>
          </div>
          <div>
            <AvailabilityPill event={this.props} />
          </div>
          {this.props.isPopover && (
            <a
              target="_blank"
              href={this.props.url}
              className="u-absolute u-bottom-0 u-right-0 u-mb-3 u-mr-3">
              <i className="Icon Icon-link"></i>
            </a>
          )}
        </div>
      </li>
    );
  }
}

class ThinAgendaEvent extends Component {
  static propTypes = {
    isVirtualFriendly: PropTypes.bool.isRequired,
    isVirtualOnly: PropTypes.bool,
    isPopover: PropTypes.bool,
    className: PropTypes.string,
    isPastSignup: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
    start_date: PropTypes.string.isRequired,
    end_date: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    communityLogoPath: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isVirtualOnly: undefined,
    className: undefined,
    isPopover: false,
  };

  handleClick = () => {
    window.location.href = this.props.url;
  };

  render() {
    let eventClasses = ['u-flex', 'u-agenda-item'];
    if (this.props.isAttending || this.props.isHosting || this.props.isPending) {
      eventClasses = eventClasses.concat(['is-attending']);
    }

    if (
      (this.props.isPastSignup || this.props.isBooked) &&
      !this.props.isPast &&
      !this.props.isHosting
    ) {
      eventClasses = eventClasses.concat(['is-unavailable']);
    }

    if (this.props.isPast) {
      eventClasses = eventClasses.concat(['is-past']);
    }

    if (this.props.className) {
      eventClasses = eventClasses.concat(this.props.className);
    }

    if (moment(this.props.end_date) > new Date().getTime() > moment(this.props.start_date)) {
      eventClasses = eventClasses.concat(['is-happening-now']);
    }

    return (
      <li className={eventClasses.join(' ')} onClick={this.handleClick}>
        <div>
          <span className={`u-dot u-ml-1 u-mr-3 u-dot-${this.props.cssSufix}`}></span>
        </div>
        <div className="u-text-sm u-align-top u-text-grey u-mr-2 u-w-32 u-flex-shrink-0">
          <DateTimeIntervalDisplay
            show_date={false}
            show_timezone={false}
            useTimezone={this.props.useTimezone}
            start_date={this.props.start_date}
            end_date={this.props.end_date}
          />
        </div>
        <div className="u-mr-2 u-mt-1 u-align-top">
          <Avatar
            className="Avatar--medium"
            src={this.props.author[0].avatar}
            name={this.props.author[0].name}
            type={this.props.author[0].type}
          />
        </div>
        <div className="u-flex-grow">
          <div className="u-font-semibold u-text-sm u-align-top u-text-blue">
            {this.props.title}
          </div>
          <div className="u-flex">
            <div
              className="u-text-sm u-text-grey"
              dangerouslySetInnerHTML={{
                __html: this.props.summary.replace(/<\/?[^>]+(>|$)/g, ''),
              }}
            />
          </div>
          <div>
            <CardTagLine
              className="u-mt-1"
              tagClassName="u-topic u-topic--grey u-topic--small u-topic--solid--grey"
              seeMoreURL={this.props.url}
              tags={this.props.tags}
              maxTags={this.props.maxTags}
              keyIdentifier={this.props.title}
            />
          </div>
        </div>
        <div className="u-flex-shrink-0 u-ml-2">
          <AvailabilityPill event={this.props} className="u-mb-1" />
        </div>
      </li>
    );
  }
}

class CustomAgenda extends Component {
  static propTypes = {
    useTimezone: PropTypes.string.isRequired,
    onSelectEvent: PropTypes.func.isRequired,
    length: PropTypes.number.isRequired,
    events: PropTypes.array,
    date: PropTypes.instanceOf(Date),

    selected: PropTypes.object,

    accessors: PropTypes.object.isRequired,
    components: PropTypes.object.isRequired,
    getters: PropTypes.object.isRequired,
    localizer: PropTypes.object.isRequired,
  };

  static title = (date, { localizer }) => '';

  static navigate = (date, action, props) => {
    switch (action) {
      case 'PREV':
        return moment(date).add(props.length > 1 ? -7 : -1, 'days');

      case 'NEXT':
        return moment(date).add(props.length > 1 ? 7 : 1, 'days');

      default:
        return date;
    }
  };

  render() {
    const from =
      this.props.length === 1
        ? moment(this.props.date).tz(this.props.useTimezone)
        : moment(this.props.date).tz(this.props.useTimezone).startOf('isoWeek');
    const to = moment(this.props.date)
      .tz(this.props.useTimezone)
      .startOf('isoWeek')
      .add(this.props.length, 'days');
    const days = this.props.events
      .filter((event) => {
        const s = moment(event.start_date).tz(this.props.useTimezone);
        const e = moment(event.end_date).tz(this.props.useTimezone);
        return (
          (s.isSameOrAfter(from) && s.isSameOrBefore(to)) ||
          (e.isSameOrAfter(from) && e.isSameOrBefore(to))
        );
      })
      .reduce((acc, item) => {
        const eventDate = moment(item.start_date).tz(this.props.useTimezone).format('YYYY-MM-DD');
        if (Object.keys(acc).indexOf(eventDate) === -1) {
          acc[eventDate] = [item];
        } else {
          acc[eventDate].push(item);
        }
        return acc;
      }, {});

    const items = Object.keys(days).map((day) => {
      const dateHeader = moment(day).format('dddd D');
      return (
        <div className={'Agenda u-pt-4'} key={dateHeader}>
          <div className={'Agenda-dateHeader u-font-semibold'}>{dateHeader}</div>
          <ul className="Agenda-table u-list-reset u-m-0">
            {days[day].map((event) => (
              <ThinAgendaEvent
                key={event.url}
                {...event}
                useTimezone={this.props.useTimezone}
                onSelectEvent={this.props.onSelectEvent}
              />
            ))}
          </ul>
        </div>
      );
    });

    return <div>{items}</div>;
  }
}

class CustomEvent extends Component {
  static propTypes = {
    event: PropTypes.object.isRequired,
    useTimezone: PropTypes.string.isRequired,
  };

  render() {
    const { event } = this.props;
    let classNames = `${event.type} ${event.isPast ? 'is-past' : ''} ${
      (event.isPastSignup || !event.isBookable) && !event.isAttending && !event.isHosting
        ? 'is-unavailable'
        : ''
    } `;
    classNames += `${
      event.isAttending || event.isHosting || event.isPending ? 'is-attending' : ''
    } `;
    classNames += 'u-absolute u-inset-0 u-p-1 u-overflow-hidden';

    const eventPopoverContent = (
      <AgendaEvent
        key={event.url}
        {...event}
        isPopover={true}
        useTimezone={this.props.useTimezone}
      />
    );

    let eventPopoverPlacement =
      moment(event.start_date).tz(this.props.useTimezone).format('H') > 8 ? 'top-' : 'bottom-';
    if (
      moment(event.start_date).tz(this.props.useTimezone).format('d') !==
        moment(event.end_date).tz(this.props.useTimezone).format('d') ||
      event.isAllDay
    ) {
      eventPopoverPlacement = 'bottom-';
    }
    eventPopoverPlacement +=
      moment(event.start_date).tz(this.props.useTimezone).format('e') > 3 ? 'right' : 'left';

    const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;

    return (
      <PopoverTrigger
        inPlace={isDesktop}
        triggerId={event.id}
        icon={false}
        popoverClass={`tooltip-event`}
        placement={eventPopoverPlacement}
        popoverContent={eventPopoverContent}>
        <div className={classNames}>
          <span className="rbc-event-title">{event.title}</span>
          <span className="rbc-event-timestamp">
            <DateTimeIntervalDisplay
              show_date={false}
              show_timezone={true}
              useTimezone={this.props.useTimezone}
              start_date={event.start_date}
              end_date={event.end_date}
            />
          </span>
        </div>
      </PopoverTrigger>
    );
  }
}

class CustomToolbar extends Component {
  static propTypes = {
    view: PropTypes.string.isRequired,
    agendaView: PropTypes.string,
    views: PropTypes.arrayOf(PropTypes.string).isRequired,
    label: PropTypes.node.isRequired,
    localizer: PropTypes.object,
    onNavigate: PropTypes.func.isRequired,
    isAgenda: PropTypes.bool.isRequired,
    onView: PropTypes.func.isRequired,
    onAgendaViewChange: PropTypes.func.isRequired,
    length: PropTypes.number.isRequired,
  };

  constructor(props) {
    super(props);
  }

  navigate = (action) => {
    this.props.onNavigate(action);
  };

  view = (view) => {
    if (this.props.isAgenda) {
      this.props.onAgendaViewChange(view);
    } else {
      this.props.onView(view);
    }
  };

  viewSelector(messages) {
    let viewOptions = this.props.views.map((name) => {
      if (name !== 'agenda') {
        return (
          <option key={name} value={name}>
            {messages[name]}
          </option>
        );
      }
    });

    const activeView = this.props.isAgenda ? this.props.agendaView : this.props.view;

    return (
      <select
        className="rbc-view-selector"
        name="view-selector"
        onChange={(e) => this.view(e.target.value)}
        defaultValue={activeView}>
        {viewOptions}
      </select>
    );
  }

  onChangeDate = (value) => {
    this.props.onNavigate(null, value);
  };

  render() {
    let {
      localizer: { messages },
      label,
    } = this.props;

    if (this.props.isAgenda) {
      const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
      const formatString = isDesktop ? 'MMMM D' : 'MMM D';
      const fromDate =
        this.props.length === 1
          ? moment(this.props.date)
          : moment(this.props.date).startOf('isoWeek');
      const toDate = ` - ${moment(this.props.date)
        .startOf('isoWeek')
        .add(this.props.length - 1, 'days')
        .format(formatString)}`;
      label = `${fromDate.format(formatString)}${this.props.length > 1 ? toDate : ''}, ${moment(
        this.props.date
      )
        .startOf('isoWeek')
        .add(this.props.length, 'days')
        .format('YYYY')}`;
    }

    messages['work_week'] = 'Week';
    messages['week'] = 'Week + weekend';

    return (
      <div className="rbc-toolbar">
        <div className="u-flex u-items-center">
          <div className="u-items-center u-flex u-w-40">
            <div className="u-w-8 u-h-8">
              <DateTimeInput
                minimized={true}
                useTimezone={this.props.useTimezone}
                defaultValue={moment(this.props.date).format()}
                time={false}
                onChange={this.onChangeDate}
              />
            </div>
            <div className="rbc-btn-group u-flex u-items-center">
              <button
                className="u-text-lg"
                type="button"
                onClick={this.navigate.bind(null, 'PREV')}>
                <i className="Icon-chevron-left" />
              </button>
              <button
                className="u-text-xs"
                type="button"
                onClick={this.navigate.bind(null, 'TODAY')}>
                {messages.today}
              </button>
              <button
                className="u-text-lg"
                type="button"
                onClick={this.navigate.bind(null, 'NEXT')}>
                <i className="Icon-chevron-right" />
              </button>
            </div>
          </div>
        </div>
        <div className="rbc-toolbar-label">{label}</div>
        <div className="rbc-btn-group views-nav u-hidden md:u-block">
          {this.viewSelector(messages)}
        </div>
      </div>
    );
  }
}

class CustomHeader extends Component {
  static propTypes = {
    date: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className="rbc-header-custom">
        <span>{moment(this.props.date).format('ddd')}</span>
        <span>{moment(this.props.date).format('D')}</span>
      </div>
    );
  }
}

export default class ProgrammingCalendar extends Component {
  static propTypes = {
    isAgenda: PropTypes.bool.isRequired,
    date: PropTypes.any.isRequired,
    apiUrl: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
    isMentor: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);

    Calendar.tz = moment.tz.guess();
    // format all dates in Calendar as they would be rendered in browser's local timezone (even if later on they won't)
    const m = (...args) => moment.tz(...args, Calendar.tz);
    m.localeData = moment.localeData;

    const localizer = momentLocalizer(m);

    const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    const defaultView = isDesktop ? 'work_week' : 'day';
    const defaultLength = isDesktop ? 5 : 1;
    const params = qs.parse(window.location.search.slice(1));

    this.state = {
      date: moment.tz(props.date, this.props.useTimezone),
      from: moment.tz(props.date, this.props.useTimezone).startOf('week'),
      to: moment.tz(props.date, this.props.useTimezone).endOf('week'),
      length: Number(params.length) || defaultLength,
      agendaView: params.view || defaultView,
      events: [],
      loading: true,
      view: params.view || defaultView,
      localizer,
    };
  }

  convertDateTimeToDate = (datetime, timeZoneName) => {
    const m = moment.tz(datetime, timeZoneName);
    return new Date(m.year(), m.month(), m.date(), m.hour(), m.minute(), 0);
  };

  handleLoad = (callback) => {
    const params = qs.parse(window.location.search.slice(1));

    if (this.request) this.request.cancel('Canceled');

    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.request = source;

    axios
      .get(this.props.apiUrl, {
        params,
        paramsSerializer: (p) => qs.stringify(p, { arrayFormat: 'brackets', depth: 2 }),
        cancelToken: source.token,
      })
      .then((response) => {
        this.request = null;

        let data = response.data.map((d) => {
          if (d.slots && d.isAttending) {
            let attending_slot = d.slots.find((s) => s.isAttending);
            return Object.assign({}, d, {
              start_date: attending_slot.start_date,
              end_date: attending_slot.end_date,
            });
          } else {
            return d;
          }
        });
        this.setState(
          {
            loading: false,
            events: this.state.events.concat(data),
          },
          callback
        );
      })
      .catch(function (thrown) {
        if (axios.isCancel(thrown)) {
          console.error('Request canceled', thrown.message);
        } else {
          console.error('Error', thrown.message);
        }
      });
  };

  handleParamsChange = (data) => {
    const params = qs.parse(window.location.search.slice(1));
    if (data.state && data.state.revisitWithSearch) {
      if (window.location.search.slice(1).length > 0) {
        $('.union-tab-anchor > a').each(function () {
          const params = window.location.search.slice(1);
          const newHref = $(this).attr('href').split('?')[0] + '?' + params;
          $(this).attr('href', newHref);
        });
      }
      if (data.state.removedType) {
        const params = qs.parse(window.location.search.slice(1));
        const types = params.type ? params.type.map((p) => StringUtil.camelize(p)) : [];
        const newEvents = this.state.events.slice(0).filter((e) => types.indexOf(e.type) !== -1);
        this.setState({
          events: newEvents,
        });
      }
      if (params['show_all_events'] === 'false') {
        const newEvents = this.state.events
          .slice(0)
          .filter((e) => e.isAttending || e.isHosting || e.isPending);
        this.setState({
          events: newEvents,
        });
      } else {
        this.setState(
          {
            loading: true,
            events: [],
          },
          this.handleLoad
        );
      }
    }
  };

  handleDateChange = (date) => {
    const d = moment.tz(date, this.props.useTimezone);
    const params = qs.parse(window.location.search.slice(1));
    const newState = {
      date: d,
      from: moment(d).startOf('week'),
      to: moment(d).endOf('week'),
    };
    params.date = d.format('YYYY-MM-DD');
    const revisitWithSearch = this.state.from.isAfter(d) || this.state.to.isBefore(d);

    this.setState(newState, () => {
      router.push({
        pathname: location.pathname,
        search: qs.stringify(params, { arrayFormat: 'brackets' }),
        state: { revisitWithSearch },
      });
    });
  };

  viewChanged = (view) => {
    const params = qs.parse(window.location.search.slice(1));
    if (view === 'day') {
      params.length = 1;
    } else if (view === 'work_week') {
      params.length = 5;
    } else if (view === 'week') {
      params.length = 7;
    } else if (view === 'month') {
      params.length = 30;
    }
    params.view = view;
    const newState = { length: params.length };
    if (this.props.isAgenda) {
      newState.agendaView = view;
    } else {
      newState.view = view;
    }

    this.setState(newState, () => {
      router.push({
        pathname: location.pathname,
        search: qs.stringify(params, { arrayFormat: 'brackets' }),
        state: { revisitWithSearch: true },
      });
    });
  };

  availableViews = () => ({ day: true, work_week: true, week: true, agenda: CustomAgenda });

  componentDidMount() {
    this.unlistenParamsChange = router.listen(this.handleParamsChange);
    // this is not really necessary, but just to be sure, let's defer the call to
    // handleParamsChange to after the document has finished loading, so that we capture and send the correct
    // headers to the XHR
    $(() => this.handleParamsChange({ state: { revisitWithSearch: true } }));
  }

  componentWillUnmount() {
    this.unlistenParamsChange();
  }

  CustomToolbarCapsule = (props) => {
    return class CustomToolbarInstance extends CustomToolbar {
      static defaultProps = { ...props };
    };
  };

  CustomEventCapsule = (props) => {
    return class CustomEventInstance extends CustomEvent {
      static defaultProps = { ...props };
    };
  };

  render() {
    const loadingIndicator = this.state.loading ? (
      <div className="loading">
        <span>Loading events...</span>
      </div>
    ) : null;

    const isDesktop = window.matchMedia && window.matchMedia('(min-width: 768px)').matches;
    const formatString = isDesktop ? 'MMMM D' : 'MMM D';

    const formats = {
      dayFormat: 'ddd[\n]D',
      dayHeaderFormat: `${formatString}, YYYY`,
      timeGutterFormat: 'h A',
      dayRangeHeaderFormat: ({ start, end }, culture, localizer) => {
        return `${moment(start).format(formatString)} - ${moment(end).format(
          formatString
        )}, ${moment(end).format('YYYY')}`;
      },
      agendaHeaderFormat: ({ start, end }, culture, localizer) => {
        return `${moment(start).format(formatString)} - ${moment(end).format(
          formatString
        )}, ${moment(end).format('YYYY')}`;
      },
    };

    const components = {
      toolbar: this.CustomToolbarCapsule({
        isAgenda: this.props.isAgenda,
        onAgendaViewChange: this.viewChanged,
        length: this.state.length,
        agendaView: this.state.agendaView,
      }),
      event: this.CustomEventCapsule({ useTimezone: this.props.useTimezone }),
      header: CustomHeader,
    };

    const views = this.availableViews();

    return (
      <div className="rbc-wrapper">
        {loadingIndicator}
        <Calendar
          localizer={this.state.localizer}
          defaultDate={this.state.date.toDate()}
          events={this.state.events}
          formats={formats}
          getNow={() => this.convertDateTimeToDate(new Date(), this.props.useTimezone)}
          allDayAccessor={(event) =>
            moment(event.start_date).add(24, 'hours').isSameOrBefore(event.end_date)
          }
          startAccessor={(event) =>
            this.convertDateTimeToDate(event.start_date, this.props.useTimezone)
          }
          endAccessor={(event) =>
            this.convertDateTimeToDate(event.end_date, this.props.useTimezone)
          }
          onView={this.viewChanged}
          defaultView={this.props.isAgenda ? 'agenda' : this.state.view}
          drilldownView={'day'}
          components={components}
          length={this.state.length}
          views={views}
          onNavigate={this.handleDateChange}
          useTimezone={this.props.useTimezone}
          isAgenda={this.props.isAgenda}
          scrollToTime={this.convertDateTimeToDate(
            moment.max(
              moment.tz(this.props.useTimezone).startOf('day'),
              moment.tz(this.props.useTimezone).subtract(2, 'hours')
            ),
            this.props.useTimezone
          )}
        />
      </div>
    );
  }
}
